import { TechSpaceErrorType } from "./index98.js";
import { errorHandler } from "./index101.js";
import { calculateSpaceSize } from "./index114.js";
import { createTechnicalSpaceForPodium } from "./index115.js";
import { implementSizeConstraints } from "./index116.js";
import { positionSpaces } from "./index120.js";
import { RG_TYPE } from "@project-rouge/rg-core";
function insertPodiumSpaces(spaces, building, freeAreas, sizeConstraints, forceInvalid, dataset) {
	const apartmentsAndTechSpaces = [];
	const invalidSpaces = [];
	const spacesAdded = [];
	const techSpaces = [];
	for (const space of spaces) {
		const result = implementSizeConstraints(space, sizeConstraints.maxHeight, sizeConstraints.maxDepth, forceInvalid);
		if (result.success) {
			const size = calculateSpaceSize(result.size);
			const techSpace = createTechnicalSpaceForPodium({
				building,
				space: space.space,
				includes: space.includes,
				dataset
			}, size);
			techSpaces.push({
				space: techSpace,
				invalidated: result.invalidated,
				spaceRequired: result.size
			});
		} else invalidSpaces.push({
			name: space.space.name,
			space: space.space,
			includes: space.includes,
			error: result.error
		});
	}
	const { technicalSpaces, leftover: outOfSpace } = positionSpaces({
		spaces: techSpaces.map((item) => item.space),
		availableFreeAreas: freeAreas,
		building
	});
	apartmentsAndTechSpaces.push(...technicalSpaces);
	for (const obj of outOfSpace.map((space) => techSpaces.find((s) => s.space === space))) if (obj) {
		const rooms = obj.space.children.filter((c) => c.type === RG_TYPE.TechnicalSpaceRoom);
		invalidSpaces.push({
			name: obj.space.name,
			space: obj.space.data.instance,
			includes: rooms.map((r) => r.data.instance),
			error: errorHandler(TechSpaceErrorType.NoSpaceLeft, {
				spaceRequired: obj.spaceRequired,
				invalidatedSize: obj.invalidated
			})
		});
	}
	for (const obj of techSpaces.filter((s) => !outOfSpace.find((space) => space === s.space))) {
		const rooms = obj.space.children.filter((c) => c.type === RG_TYPE.TechnicalSpaceRoom);
		spacesAdded.push({
			name: obj.space.name,
			space: obj.space.data.instance,
			includes: rooms.map((r) => r.data.instance),
			size: {
				area: obj.space.size[0] * obj.space.size[2],
				sizeX: obj.space.size[0],
				sizeY: obj.space.size[1],
				sizeZ: obj.space.size[2]
			},
			invalidatedSize: obj.invalidated,
			consolidated: !!obj.space.data.instance.consolidationType,
			level: obj.space.data.level
		});
	}
	return {
		apartmentsAndTechSpaces,
		spacesAdded,
		invalidSpaces
	};
}
export { insertPodiumSpaces };

//# sourceMappingURL=index121.js.map